var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgChallengeDeadlineAppoaching = function SvgChallengeDeadlineAppoaching(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 39,
    viewBox: "0 0 43 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 427319106"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 678",
    d: "M38.0769 37L27.7564 15.5513M38.0769 37H4.87179M38.0769 37H40.9487M27.7564 15.5513L19.3205 27.9359L13.4872 23.4487L4.87179 37M27.7564 15.5513V7.29487M4.87179 37H2M27.7564 7.29487V2H37.1795V7.29487H27.7564Z",
    stroke: "#4239FB",
    strokeWidth: 2.21198,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 683",
    d: "M23.3001 36.6888V22.083L19.6486 27.5602L13.5629 23.9087L5.04285 36.6888H23.3001Z",
    fill: "#4239FB"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgChallengeDeadlineAppoaching);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDMiIGhlaWdodD0iMzkiIHZpZXdCb3g9IjAgMCA0MyAzOSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgaWQ9Ikdyb3VwIDQyNzMxOTEwNiI+CjxwYXRoIGlkPSJWZWN0b3IgNjc4IiBkPSJNMzguMDc2OSAzN0wyNy43NTY0IDE1LjU1MTNNMzguMDc2OSAzN0g0Ljg3MTc5TTM4LjA3NjkgMzdINDAuOTQ4N00yNy43NTY0IDE1LjU1MTNMMTkuMzIwNSAyNy45MzU5TDEzLjQ4NzIgMjMuNDQ4N0w0Ljg3MTc5IDM3TTI3Ljc1NjQgMTUuNTUxM1Y3LjI5NDg3TTQuODcxNzkgMzdIMk0yNy43NTY0IDcuMjk0ODdWMkgzNy4xNzk1VjcuMjk0ODdIMjcuNzU2NFoiIHN0cm9rZT0iIzQyMzlGQiIgc3Ryb2tlLXdpZHRoPSIyLjIxMTk4IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggaWQ9IlZlY3RvciA2ODMiIGQ9Ik0yMy4zMDAxIDM2LjY4ODhWMjIuMDgzTDE5LjY0ODYgMjcuNTYwMkwxMy41NjI5IDIzLjkwODdMNS4wNDI4NSAzNi42ODg4SDIzLjMwMDFaIiBmaWxsPSIjNDIzOUZCIi8+CjwvZz4KPC9zdmc+Cg==";